import React, { useEffect, useState } from 'react';
import { Dropdown, UploadWhiteIcon } from '../../svg';
import { useFormik } from 'formik';
import * as yup from "yup";
import settingStyle from './settings.module.css'
import { CircularProgress, MenuItem, Select } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile, setLogin } from '../redux/userSlice';
import { updatePassword, updateProfile } from '../redux/settingSlice';
import api from '../helper/Api';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ChangePassword from '../../component/ChangePassword';
import Toastify from '../helper/Toastify';
import OtpModal from '../../component/otpModal';
import DeleteAccount from '../../component/DeleteAccount';
import { state } from '../helper/data';
import Selects from "react-select";


const Settings = ({ getUserProfile }) => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false)
    const [Data, setData] = useState([])
    const [deleteModal, setDeleteModal] = useState(false);
    const [datas, setdatas] = useState([])

    const openDeleteModal = (data) => {
        setdatas(data)
        setDeleteModal(true)
    }
    const closeDeleteModal = () => {
        setDeleteModal(false)
    }
    const schema = yup.object().shape({
        name: yup.string().required("Name is required"),
        email: yup.string().required("Email is required"),
        phone: yup.number().min(1, "Value must be number").required("Phone is required"),
        city: yup.string().required("City is required"),
        state: yup.string().required("State is required"),
        locality: yup.string().required("Locality is required"),
        pincode: yup.string().matches(/^\d{6}$/, "Pincode must be 6 digit long").required("pincode is required")
    })

    const {
        errors,
        values,
        handleChange,
        touched,
        setValues,
        handleBlur,
        handleSubmit,
        setFieldValue,
    } = useFormik({
        initialValues: {
            name: "",
            profileImg: [],
            email: "",
            phone: 0,
            city: "",
            state: "",
            locality: "",
            pincode: "",
            gender: "",
            bio: "",

        },
        validationSchema: schema,
        onSubmit: (values) => {
            setData(values)
            if (!loading) {
                updateSubject(values)
            }
        }
    })

    const updateSubject = async () => {
        try {
            setLoading(true)
            const { data, status } = await api.updateProfile(values)

            if (data.data.message === 'Update Successfull') {
                dispatch(setLogin(data?.data?.data))
                Toastify.success("Profile Updated Successfully")

            } else {
                //modal open
                setShowModal(true)
            }

        } catch (error) {
            console.log("error uploading details", error)
            Toastify.error(error.response.data.message || `something went wrong`)
        } finally {
            setTimeout(() => {
                setLoading(false)
            }, 200);
        }
    }



    useEffect(() => {
        if (getUserProfile) {
            setValues({
                name: getUserProfile?.name || '',
                profileImg: getUserProfile?.profileImg || [],
                email: getUserProfile?.email || '',
                phone: getUserProfile?.phone || '',
                state: getUserProfile?.state || '',
                pincode: getUserProfile?.pincode || '',
                city: getUserProfile?.city || '',
                locality: getUserProfile?.locality || '',
                bio: getUserProfile?.bio || '',
                gender: getUserProfile?.gender || ''
            })
        }
    }, [getUserProfile, setValues])

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const body = new FormData();
            body.set("image", file);
            const { data, status } = await api.fileUpload(body);
            console.log(data, "data");

            if (status === 200) {
                setFieldValue("profileImg", data.data); // replace the current image with the new one
            }
        }
    };


    const maskEmail = (email) => {
        if (!email || typeof email !== 'string') {
            return ""; // Return an empty string or a default masked email if the input is invalid
        }
        const [username, domain] = email?.split("@"); // Split into username and domain
        if (username.length <= 2) {
            // If the username is too short, keep only the first character and mask the rest
            return `${username[0]}***@${domain}`;
        }
        // Otherwise, keep the first two characters and mask the rest
        return `${username.substring(0, 2)}***@${domain}`;
    };

    return (
        <div className={settingStyle.settingWrapper} >


            <h3 className={settingStyle.accountHeading}>Account Settings</h3>

            <div className={settingStyle.mainContainer}>
                <div className={settingStyle.imageCard}>
                    <label htmlFor="upload-photo" className={settingStyle.uploadOverlay}>
                        {values?.profileImg?.length > 0 ? (
                            <img src={values?.profileImg} alt="Profile" className={settingStyle.uploadedImage} />
                        ) : (
                            <div className={settingStyle.uploadPlaceholder}>Upload Photo</div>
                        )}
                        <div className={settingStyle.overlayText}><UploadWhiteIcon />Upload Photo</div>
                    </label>
                    <input
                        type="file"
                        id="upload-photo"
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ display: 'none' }}
                    />

                    <p className={settingStyle.imageGuidelines}>
                        Image size 280 x 280, 1MB and image ratio needs to be 1:1
                    </p>
                </div>
                <div className={settingStyle.accountCard}>
                    <h3 className={settingStyle.accountH3}>Account</h3>
                    <div className={settingStyle.cardContainer}>
                        <div className={settingStyle.widthStyle}>
                            <label className={settingStyle.labelStyle}>Student name</label>
                            <div className={settingStyle.inputBox} >
                                <input type='text' disabled onBlur={handleBlur} value={values.name}
                                    // placeholder='Your Name...'
                                    name="name" onChange={handleChange} />
                            </div>
                            {
                                errors.name && touched.name && <p style={{ color: "red", fontSize: "12px" }}>{errors.name}</p>
                            }
                        </div>
                        <div className={settingStyle.widthStyle}>
                            <label className={settingStyle.labelStyle}>Email Id</label>
                            <div className={settingStyle.inputBox}>
                                <input type='text' onBlur={handleBlur} value={values.email}
                                    //  placeholder='Your Email Id...'
                                    name="email" onChange={handleChange} />
                            </div>
                            {
                                errors.email && touched.email && <p style={{ color: "red", fontSize: "12px" }}>{errors.email}</p>
                            }
                        </div>
                    </div>
                    <div className={settingStyle.cardContainer} style={{ paddingTop: 20 }}>
                        <div className={settingStyle.widthStyle}>
                            <label className={settingStyle.labelStyle}>Contact number</label>
                            <div className={settingStyle.inputBox}>
                                <input type='number' onBlur={handleBlur} value={values.phone || ''}
                                    // placeholder='Your Contact Number...'
                                    name="phone" onChange={handleChange} />
                            </div>
                            {
                                errors.phone && touched.phone && <p style={{ color: "red", fontSize: "12px" }}>{errors.phone}</p>
                            }
                        </div>
                        <div className={settingStyle.widthStyle}>
                            <label className={settingStyle.labelStyle}>Gender</label>
                            <div>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    sx={{
                                        width: '100%',
                                        height: '50px',
                                        color: '#8D8D8D',
                                        fontFamily: 'Poppins',
                                        lineHeight: '20px',
                                        fontSize: '14px',
                                        outline: 'none !important',
                                        borderRadius: '16px',
                                        padding: '16px',
                                        backgroundColor: '#fff',
                                        border: '1px solid var(--Gray-100, #E0E2E7) !important',
                                        ".MuiSelect-select": {
                                            padding: '12px 1px !important',

                                        },
                                        ".MuiOutlinedInput-notchedOutline": {
                                            border: "none !important",
                                        },

                                    }}
                                    IconComponent={ArrowDropDownIcon}
                                    displayEmpty
                                    defaultValue=''
                                    name={'gender'}
                                    value={values.gender}
                                    onChange={(e) => {
                                        handleChange(e);
                                    }}
                                    style={{ fontWeight: '400', fontSize: 14, color: '#333' }}
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    <MenuItem value="MALE">Male</MenuItem>
                                    <MenuItem value="FEMALE">Female</MenuItem>
                                    <MenuItem value="OTHERS">Others</MenuItem>

                                </Select>
                            </div>
                        </div>
                    </div>
                    <div className={settingStyle.cardContainer} style={{ paddingTop: 20 }}>
                        <div className={settingStyle.widthStyle}>
                            <label className={settingStyle.labelStyle}>State</label>
                            <div className={settingStyle.inputBox}>
                                <Selects
                                    options={[{
                                        options: Object.keys(state)?.map((state) => {
                                            return {
                                                value: state,
                                                label: state,
                                            }
                                        })
                                    }]}
                                    value={{
                                        value: values?.state,
                                        label: values?.state,
                                    }}
                                    name='state'
                                    // components={{ Option, GroupHeading }}
                                    styles={{ container: (styles) => ({ ...styles, width: "100%" }), singleValue: (styles) => ({ ...styles, fontSize: "13px", paddingLeft: "12px" }), control: (styles) => ({ ...styles, padding: "3px 0", border: "none", borderColor: "transparent !important", boxShadow: "none" }) }}
                                    onChange={(value) => handleChange({
                                        target: {
                                            value: value.value,
                                            name: "state"
                                        }
                                    })}
                                />
                            </div>
                            {
                                errors.state && touched.state && <p style={{ color: "red", fontSize: "12px" }}>{errors.state}</p>
                            }
                        </div>
                        <div className={settingStyle.widthStyle}>
                            <label className={settingStyle.labelStyle}>City</label>
                            <div className={settingStyle.inputBox}>
                                <input type='text' onBlur={handleBlur} value={values.city || ''}
                                    // placeholder='Your City...' 
                                    name="city" onChange={handleChange} />
                            </div>
                            {
                                errors.city && touched.city && <p style={{ color: "red", fontSize: "12px" }}>{errors.city}</p>
                            }
                        </div>
                    </div>
                    <div className={settingStyle.cardContainer} style={{ paddingTop: 20 }}>
                        <div className={settingStyle.widthStyle}>
                            <label className={settingStyle.labelStyle}>Home Address</label>
                            <div className={settingStyle.inputBox}>
                                <input type='text' onBlur={handleBlur} value={values.locality || ''}
                                    //  placeholder='Your City...'
                                    name="locality" onChange={handleChange} />
                            </div>
                            {
                                errors.locality && touched.locality && <p style={{ color: "red", fontSize: "12px" }}>{errors.locality}</p>
                            }
                        </div>
                        <div className={settingStyle.widthStyle}>
                            <label className={settingStyle.labelStyle}>Pincode</label>
                            <div className={settingStyle.inputBox}>
                                <input type='text' onBlur={handleBlur} value={values.pincode || ''}
                                    //  placeholder='Your City...'
                                    name="pincode" onChange={handleChange} />
                            </div>
                            {
                                errors.pincode && touched.pincode && <p style={{ color: "red", fontSize: "12px" }}>{errors.pincode}</p>
                            }
                        </div>
                    </div>
                    <div style={{ paddingTop: 20, width: '100%' }}>
                        <label className={settingStyle.labelStyle}>Bio</label>
                        <div className={settingStyle.inputBox} style={{ width: '100%' }}>
                            <input type='text' onBlur={handleBlur} value={values.bio}
                                // placeholder='Your Customize Message...'
                                name="bio" onChange={handleChange} />
                        </div>
                        {
                            errors.bio && touched.bio && <p style={{ color: "red", fontSize: "12px" }}>{errors.bio}</p>
                        }
                    </div>
                    <div className={settingStyle.changesPasswordButton} onClick={handleSubmit} style={{ minWidth: "100px", opacity: loading ? 0.5 : 1 }}>
                        <p>{loading ? <CircularProgress size={20} /> : `Save`} </p>
                    </div>
                    <div className={settingStyle.bottomLine} />
                    <ChangePassword />
                    {/* <div className={settingStyle.bottomLine} />
                    <h6 className={settingStyle.headingh6}>
                        Delete Account
                    </h6>
                    <div className={settingStyle.description}>
                        If you delete your account, your personal information will be wiped from Kingster's servers,
                        all of your course activity will be anonymized and any certificates earned will be deleted. This
                        action cannot be undone! <span>Cancel any active subscriptions before you delete your account.</span>
                    </div>
                    <div className={settingStyle.changesPasswordButton} onClick={() => openDeleteModal()}>
                        <p>Delete Account</p>
                    </div> */}
                </div>
            </div>

            <OtpModal
                open={showModal}
                desc={`We have sent you an OTP to your  ${maskEmail(getUserProfile?.email)}, please check and verify.`}
                data={Data}
                closeModal={() => setShowModal(false)}
            />
            <DeleteAccount
                open={deleteModal}
                closeModal={closeDeleteModal}
            // id={datas}
            />
        </div >
    )
}

export default Settings;